import { useQuery } from '@tanstack/react-query';
import { getChatsRequest } from 'api';
import { useAuth } from 'context/AuthContext';

function useGetAllChats() {
  const { isAuthenticated } = useAuth();

  const query = useQuery({
    queryKey: ['chats'],
    queryFn: () => getChatsRequest(),
    enabled: isAuthenticated,
  });

  // Отладка
  // console.log('=== useGetAllChats Debug ===');
  // console.log('isAuthenticated:', isAuthenticated);
  // console.log('data:', query.data);
  // console.log('error:', query.error);
  // console.log('isLoading:', query.isLoading);
  // console.log('status:', query.status);

  // Исправленные строки:
  const chatsArray = query.data?.data;
  // console.log('Chats array:', chatsArray);
  // if (chatsArray && chatsArray.length > 0) {
  //   console.log('First chat:', chatsArray[0]);
  //   console.log('Participants:', chatsArray[0]?.participants);

  //   // Додатковий дебаг для учасників
  //   chatsArray[0]?.participants?.forEach((participant, index) => {
  //     console.log(`Participant ${index}:`, participant);
  //     console.log(`  - avatar:`, participant.avatar);
  //     console.log(`  - id:`, participant.id);
  //     console.log(`  - firstname:`, participant.firstname);
  //     console.log(`  - lastname:`, participant.lastname);
  //   });
  // }

  // console.log('============================');

  return query;
}

export default useGetAllChats;